import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { Toggle } from '@trp-rps-rps-shared-web/rps-shared-web-components';

const StyledToggle = styled.div`
  border-left: 1px solid ${tokens.ColorWhite200};
  width: 72px;
  display: flex;
  padding-top: 16px;
  justify-content: center;
  input {
    display: contents;
  }
  @media (max-width: 767px) {
    justify-content: right;
  }
`;

class ToggleSection extends Component<any> {
  render(): JSX.Element {
    const { isOn, id, handleIncludeExclude } = this.props;
    return (
      <StyledToggle>
        <Toggle isOn={isOn} id={id} handleToggle={handleIncludeExclude} />
      </StyledToggle>
    );
  }
}

export default ToggleSection;
